import type {
  ForUserError,
  InvalidCustomFieldsDetailsDto,
  InvalidCustomFieldsDetailsErrorsDto,
} from 'korint-sdk';
import i18next from 'i18next';

const MAX_VALUE_LENGTH = 50;

function truncate(text: string, max: number): string {
  return text.length > max ? `${text.slice(0, max).trimEnd()}…` : text;
}

function formatFieldError(error: InvalidCustomFieldsDetailsErrorsDto): string {
  const field = i18next.t(
    [`intermediaryInformationCard.fields.${error.key}`, `fields.${error.key}.label`],
    { defaultValue: error.key },
  );

  const rawValue: unknown = error.value;
  const valueStr = rawValue == null ? '' : String(rawValue);

  if (valueStr === '') {
    return i18next.t('formErrors.INVALID_CUSTOM_FIELDS.invalidField', { field });
  }

  const value = truncate(valueStr, MAX_VALUE_LENGTH);
  return i18next.t('formErrors.INVALID_CUSTOM_FIELDS.invalidValue', {
    value,
    field,
    interpolation: { escapeValue: false },
  });
}

export function buildInvalidCustomFieldsError(
  details: InvalidCustomFieldsDetailsDto,
): ForUserError {
  const lines = details.errors.map(formatFieldError);
  return {
    userError: i18next.t('formErrors.INVALID_CUSTOM_FIELDS.title'),
    userHelp:
      lines.length > 0
        ? lines.map(line => `- ${line}`).join('\n')
        : i18next.t('formErrors.INVALID_CUSTOM_FIELDS.description'),
  };
}
